import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import congrat from "../images/congrats.svg";

export default class Congratulations extends Component {
  goToDashboard() {
    console.log("gToDashboard");
  }

  render() {
    return (
      <Modal
        show={true}
        size="lg"
        backdrop="static"
        dialogClassName="taabl-modal-dialog"
        backdropClassName="taabl-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column justify-content-center align-items-center p-4">
            <img
              className="d-block my-5 img-fluid"
              src={congrat}
              alt="First slide"
            />
            <div className="text-center">
              <h2>Congratulations!</h2>
              <h6 className="mt-3 mb-3">
                <Button href="/" className="bnt-a cursor-pointer">
                  View Dashboard
                </Button>
              </h6>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      // <div
      //   className="container h-100 d-flex justify-content-center align-content-center flex-column"
      //   style={{ maxWidth: "500px" }}
      // >
      //   <img className="" src={congrat} alt="First slide" />
      //   <div className="text-center">
      //     <h2>Congratulations!</h2>
      //     <h6 className="mt-3 mb-3">
      //       <Button href="/" className="bnt-a cursor-pointer">
      //         View Dashboard
      //       </Button>
      //     </h6>
      //   </div>
      // </div>
    );
  }
}
